import { ref, type Ref } from 'vue';
import { migratedElements } from '@record-fill';
import { matrixBuilderApi } from '@/features/FormBuilder';
import { collectMatrixFields } from '../lib/matrix-fields';
import type { MatrixField } from './matrix-field.types';

export interface UseMatrixFields {
  fields: Ref<MatrixField[]>;
  isLoading: Ref<boolean>;
  failed: Ref<boolean>;
  load: () => Promise<void>;
}

export function useMatrixFields(matrixId: Ref<number>): UseMatrixFields {
  const fields = ref<MatrixField[]>([]);
  const isLoading = ref(false);
  const failed = ref(false);

  async function load(): Promise<void> {
    isLoading.value = true;
    failed.value = false;
    try {
      const matrix = await matrixBuilderApi.loadMatrix(matrixId.value);
      fields.value = collectMatrixFields(migratedElements(matrix.matrixStructure));
    } catch {
      failed.value = true;
    } finally {
      isLoading.value = false;
    }
  }

  return { fields, isLoading, failed, load };
}
